import { forwardRef } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";

const FinalCTA = forwardRef<HTMLElement>((_, ref) => {
  const navigate = useNavigate();

  return (
    <section ref={ref} id="contact" className="section-padding bg-surface-warm">
      <div className="container-narrow">
        <div className="text-center max-w-[840px] mx-auto">
          <h2 data-reveal className="text-3xl md:text-4xl font-semibold mb-6 text-primary">
            Raise the Standard of Your Online Presence
          </h2>
          
          <p data-reveal style={{ transitionDelay: "100ms" }} className="text-soft text-lg mb-8 leading-relaxed">
            If your website doesn't reflect the professionalism you bring to every transaction, it's time for an upgrade. We'll give you an honest assessment — no pitch, no pressure.
          </p>

          <div data-reveal style={{ transitionDelay: "200ms" }}>
            <Button variant="cta" size="lg" className="w-full sm:w-auto" onClick={() => navigate("/website-review")}>
              Request a Website Review
            </Button>
            <p className="mt-4 text-sm text-soft">
              Free, honest review. No pitch.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
});
FinalCTA.displayName = "FinalCTA";

export default FinalCTA;
